<template>
<div class="container-fluid" >

  <!-- Modal CONFIRM -->
  <modalConfirm ref="confirmModal" />
  
  <!-- Modal MESSAGE -->  
  <modalMessage ref="msgModal"/>
  
  <div class="row">    
     <div class="col_">      
    </div>

    <div class="col-md-6">
      
      <form id="New" v-on:submit.prevent="submit()">

        <div class="card border-primary text-white mb-3">
          <div  class="card-header bg-info">
            <h4><i  class="fas fa-edit mr-2" aria-hidden="true"></i>NUOVO DOCUMENTO DI CARICO (DDT/FATTURA)</h4>
          </div>
          <div style="color:black" class="card-body">
            <div class="form-group">
              <h4 style="color:blue"><strong> {{supplier.name}}</strong></h4>
              <!--<supplier-select v-bind:isActive="false" v-bind:Id="doc.supplierId"></supplier-select>-->  
            </div>

            <collectionSelect  v-bind:props="collection" @update="setCollectionId"></collectionSelect>                
            <collectionOptionType v-bind:typeId="collection.typeId" @update="setCollectionTypeId"></collectionOptionType>  

            <div class="form-group mt-4">
              <label for="doc_type"><strong>Tipo documento</strong></label>
              <select required v-model="doc.typeId" class="form-control bold" id="doc_type">
                <option value="1">Fattura</option>
                <option value="2">DDT</option>
          
              </select>
            </div>
            <div class="form-group">
              <label for="number_doc"><strong>Numero documento</strong></label>
              <input v-model="doc.number" type="text" class="form-control bold" placeholder="" name="number_doc" id = "number_doc" required>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>
            <div class="form-group">
              <label for="date_doc"><strong>Data documento</strong></label>
              <input required v-model="doc.date" type="date" class="form-control bold" placeholder="" name="date_doc" id = "date_doc">
            </div>
            <div class="form-group">
                <store-select @update="setStoreId" v-bind:required="true" v-bind:isActive="true"></store-select>
              
            </div>
          </div>
        </div>
        
        <button  type="submit"   class="btn btn-primary float-right mt-1 mb-2 mr-2">                    
          PROCEDI
          <i class="fas fa-chevron-circle-right ml-2 mr-2" aria-hidden="true"></i>          
          </button>       
      </form>

      
 
    

    </div>

     <div class="col_">
      
    </div>

  </div>

 <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre> {{ doc }}</pre> 
      
    </div>




<!-- MAIN DIV -->
</div>

</template>
<script>

//import supplierSelect from '@/components/common/SupplierSelect.vue'
import storeSelect    from '@/components/common/StoreSelect.vue'
import api            from '@/api'

import collectionSelect        from '@/components/common/CollectionSelect_1.vue' 
import collectionOptionType    from '@/components/backOffice/CollectionOptionType.vue' 
import modalConfirm            from '@/components/modalDialog/ModalConfirm.vue'
import modalMessage            from '@/components/modalDialog/ModalMessage.vue'
import { v4 as uuidv4 }      from 'uuid'

import { mapGetters } from 'vuex'
export default {
  
  components: {storeSelect,collectionSelect,collectionOptionType,modalConfirm,modalMessage},  
  props: ['supplier'],
  data () {
    return {
            
      uuid            : '',
      doc             : { 'supplierId' : this.supplier.Id,
                                
      }, 
    
      collection           : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        typeId        : 1


      },
      

    }
  },

computed: 
  {
    ...mapGetters(['company']), 

  },
created()
{
    const id           = uuidv4()
    this.uuid          = id
    this.doc.companyId  =  this.company.Id   
},
methods: 
{   

  setCollectionId(Id)
    {
      
      this.collection.Id = Id
      //this.doc.collectionId = Id
      

    },
    setCollectionTypeId(Id)
    {
      this.collection.typeId = Id
      //this.doc.collectionTypeId = Id
    },
    
  setStoreId(Id,stores)
  {
    
  
    this.$set(this.doc, 'storeId', Id)
    stores.forEach(item => {
      if(item.storeId == Id)
      {
        this.doc.store = item.store
      }
    });

  },  



  async submit() {
  
  
  try {

    
      const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA REGISTRARE IL DOCUMENTO  ?',
          { title : 'CONFERMA REGISTRAZIONE DOCUMENTO' },1
        )
      if (!confirmed) return  
      
      const sp       = 'spNewDocumentSupplier'
      const payload  = {...this.doc,
                      collection : this.collection ,                   
                      sp,
                      uuid                : this.uuid
                   
                  }       

      this.$refs.confirmModal.close() 

      this.$refs.msgModal.show()
      this.$refs.msgModal.setSpinner(true)
    
      const res = await api.post(payload)
      if (res.status !== 200) 
      {
        throw new Error(res.data ||  res)
      }

    /* =========================
       CONTROLLO RISPOSTA UUID
    ========================== */

    const recordsets = res.data.recordsets
    
    if (recordsets.length == 1) 
    {
      const result = recordsets[0][0]      
      if (result.status && result.status !== 'COMPLETED') 
      {
        throw new Error('OPERAZIONE NON ESEGUITA,RIPROVARE.')
      }
            
    }

              const newId = res.data.recordsets[0][0].newId
              if(newId)
              {
                  await this.$refs.msgModal.show('DOCUMENTO REGISTRATO.',{'title':'MESSAGGIO'},4)  
                  this.$emit('update',this.doc)       
                 
              }
              else              
              {   
                    const msg = "DOCUMENTO GIA\' REGISTRATO."
                    await this.$refs.msgModal.show(msg,{'title':'MESSAGGIO'},2)                                  
                
              }
              
    }
    catch (err) {

      this.$refs.confirmModal.close()
      await this.$refs.msgModal.show(err.message,{},3)


  }
  
},


 
  
      
}
    
}    
</script>

<style scoped>




 
.bold {
  font-weight: bolder;
}

h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
}



</style>